/*
 *  THIS COMPONENT IS DEPRECATED
 *  Please use <Text /> from design-system instead
 */
import { Color, Text as DSText, TextProps as DSTextProps } from '@billy/design-system'
import { format, isValid } from 'date-fns'
import numeral from 'numeral'
import React, { ReactElement } from 'react'

import { useLocale } from '../../hooks/useLocale'

export type TextType = 'text' | 'date' | 'currency'

export interface TextProps extends DSTextProps {
  type?: TextType
  children?: string | number
  currencyColored?: boolean
}

export const Text = ({ children = '', type = 'text', currencyColored, ...rest }: TextProps): ReactElement => {
  const locale = useLocale()

  let content
  switch (type) {
    case 'date':
      content =
        typeof children === 'string' && isValid(new Date(children))
          ? format(new Date(children), 'PP', { locale })
          : 'invalid date'
      break

    case 'currency':
      content =
        (typeof children === 'string' || typeof children === 'number') && typeof +children === 'number'
          ? numeral(children).format('0,0.00')
          : 'invalid amount'
      break

    case 'text':
    default:
      content = children
  }

  const getColor = () => {
    const amount = numeral(children).value()

    return amount === null || amount > 0 ? Color.Green400 : Color.Red700
  }

  if (type === 'text' && typeof children === 'string') {
    const paragraphs = children.split('\n').filter(Boolean)

    return (
      <>
        {paragraphs.map((text, index) => (
          <DSText key={index} {...rest}>
            {text}
          </DSText>
        ))}
      </>
    )
  }

  if (type === 'currency' && currencyColored) {
    return (
      <DSText color={getColor()} {...rest}>
        {content}
      </DSText>
    )
  }

  return <DSText {...rest}>{content}</DSText>
}
